import { CircleDollarSign } from "lucide-react";

export const fmtPending = (n) =>
  `$${Number(n || 0).toLocaleString("en-CA", { minimumFractionDigits: Number(n) % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;

/** Red "Fees pending · $500" tag for closed cases / clients that still owe money. */
export function FeesPendingTag({ amount, testid }) {
  if (!amount || amount <= 0) return null;
  return (
    <span data-testid={testid} title="Closed with an unpaid balance"
      className="inline-flex items-center gap-1 whitespace-nowrap text-[10px] font-semibold text-red-700 bg-red-50 border border-red-200 px-1.5 py-0.5 rounded-full">
      <CircleDollarSign className="h-3 w-3" /> Fees pending · {fmtPending(amount)}
    </span>
  );
}

/** "Unpaid 45 days" — how long since the case was closed with money still owing. Darker = older. */
export function UnpaidAgeTag({ days, testid }) {
  if (days === undefined || days === null) return null;
  const tone = days >= 60 ? "bg-red-700 text-white border-red-700" : days >= 30 ? "bg-red-100 text-red-800 border-red-300" : "bg-amber-50 text-amber-800 border-amber-200";
  return (
    <span data-testid={testid} title="Days since the case was closed with a balance still owing"
      className={`inline-flex items-center whitespace-nowrap text-[10px] font-semibold border px-1.5 py-0.5 rounded-full ${tone}`}>
      {days === 0 ? "Unpaid since today" : `Unpaid ${days} day${days === 1 ? "" : "s"}`}
    </span>
  );
}
